import React from 'react'
import { useDispatch } from 'react-redux'

import { GlgButton } from 'Shared/components'
import BaseCloningModal from './BaseCloningModal'
import { setCloningModal } from '../../../reducers/cloning_steps'

const SaveDraftErrorModal = () => {
  const dispatch = useDispatch()

  return (<BaseCloningModal
    title={window.I18n.t('clone_leagues_sessions.modals.save_draft_error.title')}
    content={<span>{window.I18n.t('clone_leagues_sessions.modals.save_draft_error.content')}</span>}
    rightButton={<GlgButton
      className={'cls-steps-modal__right_button'}
      text={window.I18n.t('clone_leagues_sessions.modals.save_draft_error.confirm')}
      onClick={() => dispatch(setCloningModal(null))}
    />}
  />)
}

export default SaveDraftErrorModal
